var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWrongNetwork(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 82,
    viewBox: "0 0 96 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.2878 11.8229C28.2092 11.8229 19.9617 20.0704 19.9617 30.149V53.0167C19.9617 63.0953 28.2092 71.3429 38.2878 71.3429H66.534V72.5736H38.2878C27.5295 72.5736 18.7309 63.775 18.7309 53.0167V30.149C18.7309 19.3907 27.5295 10.5921 38.2878 10.5921H66.534C77.2923 10.5921 86.0909 19.3907 86.0909 30.149V53.0167H84.8601V30.149C84.8601 20.0704 76.6126 11.8229 66.534 11.8229H38.2878Z",
    fill: "url(#paint0_linear_1134_49027)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5801 80.7706C87.3071 80.7706 95.1924 72.8853 95.1924 63.1583C95.1924 53.4313 87.3071 45.546 77.5801 45.546C67.8531 45.546 59.9678 53.4313 59.9678 63.1583C59.9678 72.8853 67.8531 80.7706 77.5801 80.7706Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.5801 45.8475C68.0196 45.8475 60.2693 53.5978 60.2693 63.1583C60.2693 72.7187 68.0196 80.469 77.5801 80.469C87.1406 80.469 94.8909 72.7187 94.8909 63.1583C94.8909 53.5978 87.1406 45.8475 77.5801 45.8475ZM59.6663 63.1583C59.6663 53.2647 67.6866 45.2444 77.5801 45.2444C87.4737 45.2444 95.494 53.2647 95.494 63.1583C95.494 73.0518 87.4737 81.0721 77.5801 81.0721C67.6866 81.0721 59.6663 73.0518 59.6663 63.1583Z",
    fill: "url(#paint1_linear_1134_49027)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.5801 48.9029C69.7071 48.9029 63.3247 55.2852 63.3247 63.1583C63.3247 71.0313 69.7071 77.4136 77.5801 77.4136C85.4532 77.4136 91.8355 71.0313 91.8355 63.1583C91.8355 55.2852 85.4532 48.9029 77.5801 48.9029ZM63.1709 63.1583C63.1709 55.2003 69.6221 48.749 77.5801 48.749C85.5381 48.749 91.9894 55.2003 91.9894 63.1583C91.9894 71.1163 85.5381 77.5675 77.5801 77.5675C69.6221 77.5675 63.1709 71.1163 63.1709 63.1583Z",
    fill: "url(#paint2_linear_1134_49027)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5801 77.4906C85.4956 77.4906 91.9124 71.0738 91.9124 63.1583C91.9124 55.2428 85.4956 48.826 77.5801 48.826C69.6646 48.826 63.2478 55.2428 63.2478 63.1583C63.2478 71.0738 69.6646 77.4906 77.5801 77.4906Z",
    fill: "url(#paint3_linear_1134_49027)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3214 3.06622C18.3213 3.06632 18.3214 3.06613 18.3214 3.06622L10.2047 17.1335L2.08189 31.1946C0.924474 33.2056 2.37582 35.7183 4.69396 35.7183H21.4632V35.7244H37.1801C39.5053 35.7244 40.9547 33.2115 39.7927 31.2016L23.5466 3.06622C23.5465 3.06614 23.5466 3.0663 23.5466 3.06622C22.3841 1.05595 19.4838 1.05598 18.3214 3.06622ZM20.4047 36.7767H4.69396C1.5598 36.7767 -0.398084 33.3817 1.1645 30.6666L9.28787 16.6045L17.4048 2.53685C18.9747 -0.17869 22.893 -0.17908 24.4629 2.53646L40.7091 30.6718C40.7091 30.6719 40.709 30.6718 40.7091 30.6718C42.2792 33.3881 40.3194 36.7829 37.1801 36.7829H20.4047V36.7767Z",
    fill: "url(#paint4_linear_1134_49027)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.934 36.2475H4.69399C1.96783 36.2475 0.263216 33.2937 1.62322 30.9306L9.74629 16.8691L17.8632 2.80136C19.2294 0.438283 22.6386 0.438283 24.0048 2.80136L32.1278 16.8691L40.2509 30.9367C41.6171 33.2998 39.9124 36.2537 37.1801 36.2537H20.934V36.2475Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4478 8.42595C19.299 8.42595 18.3678 9.3572 18.3678 10.506V22.026C18.3678 23.1747 19.299 24.106 20.4478 24.106H20.4539C21.6027 24.106 22.5339 23.1747 22.5339 22.026V10.506C22.5339 9.3572 21.6027 8.42595 20.4539 8.42595H20.4478ZM17.7647 10.506C17.7647 9.02413 18.966 7.82288 20.4478 7.82288H20.4539C21.9358 7.82288 23.137 9.02413 23.137 10.506V22.026C23.137 23.5078 21.9358 24.709 20.4539 24.709H20.4478C18.966 24.709 17.7647 23.5078 17.7647 22.026V10.506Z",
    fill: "url(#paint5_linear_1134_49027)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4539 8.12439H20.4478C19.1325 8.12439 18.0662 9.19064 18.0662 10.5059V22.0259C18.0662 23.3412 19.1325 24.4075 20.4478 24.4075H20.4539C21.7692 24.4075 22.8355 23.3412 22.8355 22.0259V10.5059C22.8355 9.19064 21.7692 8.12439 20.4539 8.12439Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4539 8.12439H20.4478C19.1325 8.12439 18.0662 9.19064 18.0662 10.5059V22.0259C18.0662 23.3412 19.1325 24.4075 20.4478 24.4075H20.4539C21.7692 24.4075 22.8355 23.3412 22.8355 22.0259V10.5059C22.8355 9.19064 21.7692 8.12439 20.4539 8.12439Z",
    fill: "url(#paint6_linear_1134_49027)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4539 8.12439H20.4478C19.1325 8.12439 18.0662 9.19064 18.0662 10.5059V22.0259C18.0662 23.3412 19.1325 24.4075 20.4478 24.4075H20.4539C21.7692 24.4075 22.8355 23.3412 22.8355 22.0259V10.5059C22.8355 9.19064 21.7692 8.12439 20.4539 8.12439Z",
    fill: "url(#paint7_linear_1134_49027)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4539 27.2075C19.1081 27.2075 18.017 28.2986 18.017 29.6444C18.017 30.9903 19.1081 32.0814 20.4539 32.0814C21.7998 32.0814 22.8909 30.9903 22.8909 29.6444C22.8909 28.2986 21.7998 27.2075 20.4539 27.2075ZM17.4139 29.6444C17.4139 27.9655 18.775 26.6044 20.4539 26.6044C22.1329 26.6044 23.4939 27.9655 23.4939 29.6444C23.4939 31.3234 22.1329 32.6844 20.4539 32.6844C18.775 32.6844 17.4139 31.3234 17.4139 29.6444Z",
    fill: "url(#paint8_linear_1134_49027)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4539 32.3829C21.9663 32.3829 23.1924 31.1568 23.1924 29.6444C23.1924 28.132 21.9663 26.9059 20.4539 26.9059C18.9415 26.9059 17.7155 28.132 17.7155 29.6444C17.7155 31.1568 18.9415 32.3829 20.4539 32.3829Z",
    fill: "url(#paint9_linear_1134_49027)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M20.454 32.3829C21.9664 32.3829 23.1924 31.1568 23.1924 29.6444C23.1924 28.132 21.9664 26.9059 20.454 26.9059C18.9416 26.9059 17.7155 28.132 17.7155 29.6444C17.7155 31.1568 18.9416 32.3829 20.454 32.3829Z",
    fill: "url(#paint10_linear_1134_49027)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.3607 56.305C72.4077 55.2581 74.1125 55.2581 75.1595 56.305L78.177 59.3226L81.1946 56.305C82.2416 55.2581 83.9464 55.2581 84.9933 56.305C86.0403 57.352 86.0403 59.0568 84.9933 60.1038L81.9758 63.1213L84.9933 66.1389C86.0403 67.1859 86.0403 68.8906 84.9933 69.9376C83.9464 70.9846 82.2416 70.9846 81.1946 69.9376L78.177 66.9201L75.1595 69.9376C74.1125 70.9846 72.4077 70.9846 71.3607 69.9376C70.3138 68.8906 70.3138 67.1859 71.3607 66.1389L74.3783 63.1213L71.3607 60.1038C70.3138 59.0568 70.3138 57.352 71.3607 56.305ZM74.7331 56.7315C73.9216 55.92 72.5987 55.92 71.7872 56.7315C70.9757 57.543 70.9757 58.8659 71.7872 59.6774L75.2312 63.1213L71.7872 66.5653C70.9757 67.3768 70.9757 68.6997 71.7872 69.5112C72.5987 70.3227 73.9216 70.3227 74.7331 69.5112L78.177 66.0672L81.621 69.5112C82.4325 70.3227 83.7554 70.3227 84.5669 69.5112C85.3784 68.6997 85.3784 67.3768 84.5669 66.5653L81.1229 63.1213L84.5669 59.6774C85.3784 58.8659 85.3784 57.543 84.5669 56.7315C83.7554 55.92 82.4325 55.92 81.621 56.7315L78.177 60.1755L74.7331 56.7315Z",
    fill: "url(#paint11_linear_1134_49027)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5494 63.1214L84.7802 59.8906C85.7094 58.9614 85.7094 57.4475 84.7802 56.5183C83.8509 55.589 82.3371 55.589 81.4078 56.5183L78.1771 59.749L74.9463 56.5183C74.0171 55.589 72.5032 55.589 71.574 56.5183C70.6448 57.4475 70.6448 58.9614 71.574 59.8906L74.8048 63.1214L71.574 66.3521C70.6448 67.2814 70.6448 68.7952 71.574 69.7244C72.5032 70.6537 74.0171 70.6537 74.9463 69.7244L78.1771 66.4937L81.4078 69.7244C82.3371 70.6537 83.8509 70.6537 84.7802 69.7244C85.7094 68.7952 85.7094 67.2814 84.7802 66.3521L81.5494 63.1214Z",
    fill: "url(#paint12_linear_1134_49027)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5494 63.1214L84.7802 59.8906C85.7094 58.9614 85.7094 57.4475 84.7802 56.5183C83.8509 55.589 82.3371 55.589 81.4078 56.5183L78.1771 59.749L74.9463 56.5183C74.0171 55.589 72.5032 55.589 71.574 56.5183C70.6448 57.4475 70.6448 58.9614 71.574 59.8906L74.8048 63.1214L71.574 66.3521C70.6448 67.2814 70.6448 68.7952 71.574 69.7244C72.5032 70.6537 74.0171 70.6537 74.9463 69.7244L78.1771 66.4937L81.4078 69.7244C82.3371 70.6537 83.8509 70.6537 84.7802 69.7244C85.7094 68.7952 85.7094 67.2814 84.7802 66.3521L81.5494 63.1214Z",
    fill: "url(#paint13_linear_1134_49027)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5494 63.1214L84.7802 59.8906C85.7094 58.9614 85.7094 57.4475 84.7802 56.5183C83.8509 55.589 82.3371 55.589 81.4078 56.5183L78.1771 59.749L74.9463 56.5183C74.0171 55.589 72.5032 55.589 71.574 56.5183C70.6448 57.4475 70.6448 58.9614 71.574 59.8906L74.8048 63.1214L71.574 66.3521C70.6448 67.2814 70.6448 68.7952 71.574 69.7244C72.5032 70.6537 74.0171 70.6537 74.9463 69.7244L78.1771 66.4937L81.4078 69.7244C82.3371 70.6537 83.8509 70.6537 84.7802 69.7244C85.7094 68.7952 85.7094 67.2814 84.7802 66.3521L81.5494 63.1214Z",
    fill: "url(#paint14_linear_1134_49027)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5494 63.1214L84.7802 59.8906C85.7094 58.9614 85.7094 57.4475 84.7802 56.5183C83.8509 55.589 82.3371 55.589 81.4078 56.5183L78.1771 59.749L74.9463 56.5183C74.0171 55.589 72.5032 55.589 71.574 56.5183C70.6448 57.4475 70.6448 58.9614 71.574 59.8906L74.8048 63.1214L71.574 66.3521C70.6448 67.2814 70.6448 68.7952 71.574 69.7244C72.5032 70.6537 74.0171 70.6537 74.9463 69.7244L78.1771 66.4937L81.4078 69.7244C82.3371 70.6537 83.8509 70.6537 84.7802 69.7244C85.7094 68.7952 85.7094 67.2814 84.7802 66.3521L81.5494 63.1214Z",
    fill: "url(#paint15_linear_1134_49027)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1134_49027",
    x1: 25.8201,
    y1: 14.9921,
    x2: 74.9647,
    y2: 64.1429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#009BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#E9540E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1134_49027",
    x1: 83.7093,
    y1: 79.989,
    x2: 71.4509,
    y2: 46.3152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#009BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#E9540E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1134_49027",
    x1: 71.4843,
    y1: 76.2182,
    x2: 83.6683,
    y2: 50.1009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#009BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#E9540E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1134_49027",
    x1: 75.0632,
    y1: 58.0383,
    x2: 69.3832,
    y2: 46.4813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9540E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1134_49027",
    x1: 27.0324,
    y1: 43.269,
    x2: 6.71243,
    y2: 8.07519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#009BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#E9540E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1134_49027",
    x1: 20.4539,
    y1: 24.709,
    x2: 20.4539,
    y2: 7.82288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#009BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#E9540E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1134_49027",
    x1: 20.4539,
    y1: 18.949,
    x2: 20.4539,
    y2: 7.87208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#1997D3",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1134_49027",
    x1: 20.4539,
    y1: 14.4567,
    x2: 20.4539,
    y2: 23.7859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9540E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1134_49027",
    x1: 19.4078,
    y1: 26.7829,
    x2: 21.4939,
    y2: 32.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#009BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#E9540E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1134_49027",
    x1: 17.7093,
    y1: 29.6444,
    x2: 23.1924,
    y2: 29.6444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1999D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1134_49027",
    x1: 20.8171,
    y1: 30.1429,
    x2: 18.3986,
    y2: 26.8383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9540E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1134_49027",
    x1: 78.177,
    y1: 70.7152,
    x2: 78.177,
    y2: 55.5213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#009BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#E9540E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1134_49027",
    x1: 76.1648,
    y1: 61.1029,
    x2: 71.5371,
    y2: 56.4813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1999D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1134_49027",
    x1: 79.7155,
    y1: 61.589,
    x2: 85.0386,
    y2: 56.2598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9540E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1134_49027",
    x1: 75.5371,
    y1: 65.5275,
    x2: 71.4571,
    y2: 69.2567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9540E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1134_49027",
    x1: 80.8602,
    y1: 65.8044,
    x2: 85.0202,
    y2: 69.9644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1999D6"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrongNetwork);
export default __webpack_public_path__ + "static/media/wrong-network.50afbb741342df836f1a73aa5a18cba4.svg";
export { ForwardRef as ReactComponent };